import {
	ButtonLayout,
	ButtonPrimary,
	Grid,
	IconTimeLight,
	IconWarningLight,
	Text3,
	skinVars,
	useScreenSize,
} from "@telefonica/mistica";
import React, { useCallback, useEffect, useMemo } from "react";

import { strings } from "../../../localization";
import { FeedbackContainer, ScreenResponsive } from "../../../components";
import { observer } from "mobx-react-lite";
import { useParams } from "react-router-dom";
import { useGlobalStore } from "../../../contexts/globalStoreContext";
import { ErrorUnavailableEnum } from "../../../enum/errorUnavailable";
import { useNavigateCustom } from "../../../hooks";

const {
	contractUnavailable,
	defaultInfo,
	insufficientBalance,
} = strings.pages.errorCustomUnavailable;

const { toGoOut } = strings.components.buttons;
const iconSize = 64;

const ErrorCustomUnavailable: React.FC = observer(() => {
	const { type } = useParams() as { type: ErrorUnavailableEnum };
	const navigation = useNavigateCustom();
	const { isDesktopOrBigger } = useScreenSize();
	const { authenticationStore } = useGlobalStore();

	// redireciona para a home
	const onHandleToGoOut = useCallback(() => {
		navigation("/");
	}, []);

	// retorna informações de erro com base no type recebido por parâmetro
	const infoError = useMemo(() => {
		switch (type) {
			case ErrorUnavailableEnum.CONTRACT_UNAVAILABLE:
				return {
					icon: <IconTimeLight size={iconSize} color={skinVars.colors.brand} />,
					title: contractUnavailable.title,
					description: contractUnavailable.description,
				};
			case ErrorUnavailableEnum.INSUFFICIENT_BALANCE:
				return {
					icon: <IconWarningLight size={iconSize} color={skinVars.colors.error} />,
					title: insufficientBalance.title,
					description: insufficientBalance.description,
				};
			default:
				return {
					icon: <IconTimeLight size={iconSize} color={skinVars.colors.brand} />,
					title: defaultInfo.title,
					description: defaultInfo.description,
				};
		}
	}, [type]);

	// limpa dados do usuário
	useEffect(() => {
		authenticationStore.logout();
	}, []);

	return (
		<ScreenResponsive>
			<Grid justifyContent="center">
				<FeedbackContainer
					icon={infoError.icon}
					title={infoError.title}
					description={infoError.description}
				>
					<ButtonLayout align={isDesktopOrBigger ? "left" : "center"}>
						<ButtonPrimary onPress={onHandleToGoOut} style={{ width: isDesktopOrBigger ? "auto" : "100%" }}>
							<Text3 medium color={skinVars.colors.textButtonPrimary}>
								{toGoOut}
							</Text3>
						</ButtonPrimary>
					</ButtonLayout>
				</FeedbackContainer>
			</Grid>
		</ScreenResponsive>
	);
});

export default ErrorCustomUnavailable;
